import { useEffect, useRef } from 'react';
import { AppFile } from './types';

export const useFileUpload = ({ files, onChange }: { files: AppFile[] | null; onChange: (files: File[]) => void }) => {
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (!files?.length || !inputRef.current) {
			return;
		}

		const dt = new DataTransfer();
		files.forEach(f => dt.items.add(f.file));
		inputRef.current.files = dt.files;
	}, [files]);

	const onClickHandler = () => {
		if (!inputRef.current) {
			return;
		}

		inputRef.current.click();
	};

	const onChangeHandler = async () => {
		if (!inputRef.current) {
			return;
		}

		const { current: input } = inputRef;

		if (input.value) {
			onChange(Array.from(input.files || []));
		}
	};

	return {
		inputRef,
		onClickHandler,
		onChangeHandler
	};
};
